import { Toaster as Sonner, toast } from "sonner"

/*
  App-wide toaster (mounted once in App.js). Kit look: a calm dark navy toast docked
  bottom-right, 24px from the edges. Plain `toast.success(...)` calls and the richer
  `notify` helper (components/ui/notify.jsx — Undo button + countdown) share this look.

  While a sticky <UnsavedBar/> sits at the bottom of the viewport it sets `--toast-bottom-offset`
  on <html> (measured from the bar's position), and the toasts rise above it so they never cover
  Discard / Save / Try again.
*/
const TOASTER_STYLE = {
  "--normal-bg": "var(--toast-bg)",
  "--normal-border": "transparent",
  "--normal-text": "#ffffff",
  "--border-radius": "12px",
  "--width": "380px",
}

// --app-bottom-nav-height (phone tab bar, 0 elsewhere): toasts float above it. A measured bar offset
// already includes the tab bar, hence max() rather than a sum.
// --toast-right-offset: a docked side pane (Tasks) sets it on <html> while open, so toasts sit beside the pane
// instead of covering its fields; 0 everywhere else.
const TOASTER_OFFSET = {
  bottom: "calc(24px + var(--toast-bottom-offset, 0px))",
  right: "calc(24px + var(--toast-right-offset, 0px))",
}
const TOASTER_MOBILE_OFFSET = { bottom: "calc(16px + max(var(--toast-bottom-offset, 0px), var(--app-bottom-nav-height, 0px)))" }

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      offset={TOASTER_OFFSET}
      mobileOffset={TOASTER_MOBILE_OFFSET}
      gap={8}
      className="toaster group"
      style={TOASTER_STYLE}
      toastOptions={{
        classNames: {
          toast: "group toast",
          title: "!font-semibold",
          description: "!text-white/70",
          actionButton:
            "!h-7 !rounded-lg !bg-white/[0.12] !px-2.5 !text-[12.5px] !font-semibold !text-white hover:!bg-white/20",
          cancelButton: "!h-7 !rounded-lg !bg-transparent !text-white/70",
          success: "[&_[data-icon]]:text-[#80c804]",
          error: "[&_[data-icon]]:text-[#fca5a5]",
          warning: "[&_[data-icon]]:text-[#fcd34d]",
          info: "[&_[data-icon]]:text-[#cdcdee]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
